@if (reviewsPercentages(); as ratingDistributions) {
  <div class="col-span-6 grid grid-cols-[auto_1fr] items-end gap-2 desk:gap-x-7">
    @for (note of [5, 4, 3, 2, 1]; track note) {
      @let review = ratingDistributions | findByProperty: "rating" : note;
      @if (review) {
        <app-star-rating-display [note]="note" (click)="onRatingSelected(note)" class="cursor-pointer" />
        <app-progress-bar
          [percentage]="review.percentage"
          (click)="onRatingSelected(note)"
          class="w-full cursor-pointer"
          [class.opacity-25]="currentReviewNote() !== note && currentReviewNote() >= 0" />
      }
    }
  </div>
}
